import styled, { css } from 'styled-components'
import { em } from 'polished'
import { colors, accessibilityHoverInvert, isDefaultThemeMode } from 'core/theme'
import { Link } from 'react-router-dom'

export const StyledLink = styled(Link)`
  color: ${colors.primary};
  font-size: inherit;
  padding: 0.2em;
  margin: -0.2em;

  & > i {
    color: ${colors.lightText};
    font-size: 0.5em;
    margin-left: 0.5em;
    vertical-align: top;
  }

  &[href] {
    &:hover {
      &,
      & > i {
        color: ${colors.primaryLight};

        ${props => !isDefaultThemeMode(props) && css`
          color: ${colors.background};
        `};
      }
    }
    ${accessibilityHoverInvert};
  }
`;

export const StyledAnchor = styled.a`
  color: ${colors.primary};
  font-size: inherit;
  padding: 0.2em;
  margin: -0.2em;

  & > i {
    color: ${colors.lightText};
    font-size: 0.5em;
    margin-left: 0.5em;
    vertical-align: top;
  }

  &[href] {
    &:hover {
      &,
      & > i {
        color: ${colors.primaryLight};

        ${props => !isDefaultThemeMode(props) && css`
          color: ${colors.background};
        `};
      }
    }
    ${accessibilityHoverInvert};
  }
`;



// WEBPACK FOOTER //
// ./src/elements/Link/styled.js